export default "__VITE_ASSET__BBWyt_f6__"